import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../../api/request';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import { AcademicOfferResponse, PeriodsLoaderQuery } from '../../types';
import { getAcademicOffers } from '../../api';
import DisplayError from '../../../../../components/info/DisplayError';
import Loading from '../../../../../components/info/Loading';

export interface PeriodsLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  PeriodsLoaderQuery,
  AcademicOfferResponse,
  AxiosResultDefaultError
>();

export const usePeriods = useFetch;

export const PeriodsLoaderConsumer = FetchConsumer;

export function PeriodsLoader({ children }: PeriodsLoaderProps) {
  const request = useCallback(() => {
    return getAcademicOffers();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={{}} fetchImmediately={true}>
      <FetchConsumer>
        {({ loading, error, refresh }) => {
          if (loading) {
            return <Loading insideCard />;
          }

          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }
          return children;
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
